import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {IconsModule} from '@aztrix/icons';
import {TranslatePipe} from '@aztrix/translate';

@Component({
  selector: 'ax-agreement-status-chip',
  standalone: true,
  imports: [CommonModule, IconsModule, MatTooltipModule, TranslatePipe],
  templateUrl: './agreement-status-chip.component.html',
  styleUrl: './agreement-status-chip.component.scss',
})
export class AgreementStatusChipComponent {
  @Input() status:
    | 'not-confirmed'
    | 'expired'
    | 'deleted'
    | 'active'
    | 'confirmed'
    | 'verified'
    | 'not-verified' = 'not-confirmed';
  @Input() small = false;

  get label() {
    switch (this.status) {
      case 'not-confirmed':
        return 'agreement.status.not-confirmed';
      case 'expired':
        return 'agreement.expired';
      case 'deleted':
        return 'agreement.deleted';
      case 'active':
        return 'agreement.active';
      case 'confirmed':
        return 'agreement.status.confirmed';
      case 'verified':
        return 'agreement.verified';
      case 'not-verified':
        return 'agreement.unverified';
    }
  }

  get iconName() {
    switch (this.status) {
      case 'not-confirmed':
        return 'clock-outline';
      case 'expired':
        return 'close-thick';
      case 'deleted':
        return 'close-thick';
      case 'active':
        return 'check-bold';
      case 'confirmed':
        return 'check-bold';
      case 'verified':
        return 'check-decagram';
      case 'not-verified':
        return 'check-decagram-outline';
    }
  }
}
